<template>
  <div class="">
    <div class="formBox margbot" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
          <el-form-item label="创建时间:" class="item2">
            <el-date-picker
              v-model="createTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结算状态:">
            <el-select v-model="searchFrom.settlementStates" placeholder="请选择结算状态">
              <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="">
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
            <el-button type="primary" size="mini" @click="removeConfirm" v-if="btnFlg[1]">撤销确认</el-button>
          </el-form-item>
          <span>
            <el-form-item>
              <p class="margin0">运费总额合计：<span class="red">{{map.totalAmountSum}}</span>元</p>
            </el-form-item>
          </span>
        </div>
      </el-form>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tabref"  class="tableComent" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}" @selection-change='selectGoods'
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="130">
          <template slot-scope="scope">
            <el-button type="text" size="mini" :disabled='scope.row.isDisable' @click="daochuFN(scope.row)">导出明细</el-button>
            <el-button type="text" size="mini" @click="confirmFn(scope.row)" v-if="scope.row.settlementStates == '0' && btnFlg[0]">确认</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="账单号" width="">
          <template slot-scope="scope">
            <el-button type="text" @click="YFZDdetils(scope.row)">{{scope.row.billNo}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="状态" width="">
          <!-- 0.未收款/未付款/待确认、1.部分收款/部分付款、2.已收款/已付款/已确认 -->
          <template scope="scope">
            <span class="wsStyle" v-show="scope.row.settlementStates == '0'">未确认</span>
            <span class="ysStyle" v-show="scope.row.settlementStates == '2'">已确认</span>
          </template>
        </el-table-column>
        <el-table-column prop="payee" label="收款部门" width="">
        </el-table-column>
        <el-table-column prop="wayNumber" label="运单数量" width="">
        </el-table-column>
        <el-table-column prop="totalAmount" label="运费总额合计(元)" width="">
        </el-table-column>
        <el-table-column property="createTime" :formatter="dateTimeFormat" label="创建时间" width=""></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 应付明细 -->
    <div>
      <el-dialog :title="YFTitle" :visible.sync="YFDetilMark" :close-on-click-modal="false" width="80%" center @close="closeDialog">
        <div class="addressBox">
          <div>
            <el-table :data="listYFData" ref="listYFData" class="elTab" highlight-current-row border size="mini" style="width:100%"
            :header-cell-style="{background:'#F5F5F5',color:'black'}">
              <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
              <el-table-column prop="wayNo" label="运单号" width="230"></el-table-column>
              <el-table-column prop="" label="结算状态" width="90">
                <template scope="scope">
                  <span class="wsStyle" v-show="scope.row.yfSettlementStates == '0'">未确认</span>
                  <span class="ysStyle" v-show="scope.row.yfSettlementStates == '2'">已确认</span>
                </template>
              </el-table-column>
              <el-table-column prop="productTypeName" label="货物类型" width="120">
              </el-table-column>
              <el-table-column prop="liquidatedAmountName" label="结算量" width="120" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="freightPricingTypeName" label="运费计价" width="100" :formatter="formatterRowEmpty">
                <!-- <template scope="scope">
                  0.按吨、1.按车、2.按方、3.按件
                  <span v-show="scope.row.freightPricingType == '0'">按吨</span>
                  <span v-show="scope.row.freightPricingType == '1'">按车</span>
                  <span v-show="scope.row.freightPricingType == '2'">按方</span>
                  <span v-show="scope.row.freightPricingType == '3'">按件</span>
                </template> -->
              </el-table-column>
              <el-table-column prop="" label="运费单价" width="120">
                <template scope="scope">
                  <div>
                    <span v-if="scope.row.freightPricingType == '0'">{{scope.row.freightUnitPrice}}元/吨</span>
                    <span v-if="scope.row.freightPricingType == '1'">
                      <span v-if="scope.row.freightUnitPrice != 0">{{scope.row.freightUnitPrice}}元/车</span>
                      <span v-else>-</span>
                    </span>
                    <span v-if="scope.row.freightPricingType == '2'">{{scope.row.freightUnitPrice}}元/方</span>
                    <span v-if="scope.row.freightPricingType == '3'">{{scope.row.freightUnitPrice}}元/件</span>
                    <span v-if="scope.row.freightPricingType == '' || scope.row.freightPricingType == null">-</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="freightAmount" label="运费金额(元)" width="140" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="disburseSurcharge" label="支出附加费(元)" width="140" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="freightAmountTotal" label="运费总额(元)" width="140" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="generalCarrier" label="承运方" width="220" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="plateNumber" label="车牌号" width="130" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="driverName" label="司机姓名" width="130" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="driverPhone" label="司机电话" width="130" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="orderNo" label="订单号" width="240" :formatter="formatterRowEmpty">
              </el-table-column>
              <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
              <el-table-column prop="actualSigningTime" :formatter="dateTimeFormat" label="签收时间" width="170"></el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { getSettlementBillList, findWayBusinessList, confirmSettlementBill, revokeConfirmSettlementBill, getSettlementBillListTotal } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'Freight',
  components: {
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      YFDetilMark: false,
      YFTitle: '应付明细',
      listYFData: [],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      ysSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未确认',
          value: '0'
        },
        {
          showName: '已确认',
          value: '2'
        }
      ],
      // 查询条件
      createTime: [],
      searchFrom: {
        insideOutsideType: 0,
        paymentFlag: 1,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00M0100', '01N00M0200'],
      tableList: [],
      map: {
        totalAmountSum: 0
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/YFcalculate')
    this.createTime = getLastMonth()
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 210 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      if (this.createTime) {
        this.$set(this.searchFrom, 'createTime', this.createTime)
      } else {
        this.$set(this.searchFrom, 'createTime', null)
      }
      getSettlementBillList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      getSettlementBillListTotal(this.searchFrom).then(res => {
        this.map = res
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    selectGoods () {},
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        insideOutsideType: 0,
        paymentFlag: 1,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      this.createTime = getLastMonth()
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 账单详情
    YFZDdetils (row) {
      this.YFDetilMark = true
      this.getYFData(row.id)
    },
    getYFData (id) {
      this.loading = true
      findWayBusinessList({
        yfSettlementBillId: id
      }).then(res => {
        this.loading = false
        this.listYFData = res
      })
    },
    closeDialog () {
      this.YFDetilMark = false
    },
    // 点击确认
    confirmFn (row) {
      this.$confirm('是否操作？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        confirmSettlementBill({
          id: row.id
        }).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList()
        })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      }).catch(() => { })
    },
    // 撤销确认
    removeConfirm () {
      let selectData = this.$refs.tabref.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
      } else {
        if (selectData[0].settlementStates != '2') {
          this.$alert('只能选择已确认状态的数据', '系统提示')
        } else {
          this.$confirm('是否操作？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: '否',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            revokeConfirmSettlementBill({
              id: selectData[0].id
            }).then(res => {
              loading.close()
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.getList()
            })
              .catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
          }).catch(() => { })
        }
      }
    },
    // 导出
    daochuFN (row) {
      this.$set(row, 'isDisable', false)
      let from = {
        yfSettlementBillId: row.id
      }
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportInsideYfWayList',
        from,
        '应付明细列表'
      )
      this.$set(row, 'isDisable', true)
      setTimeout(() => {
        this.$set(row, 'isDisable', false) // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}
.inpBox .el-date-editor{
  width: 420px!important;
}
.box{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill,270px);
  grid-auto-flow: row dense;
  .item1{
    grid-row-start: span 2;
  }
  .item2{
    grid-column-start: span 2;
    width: 540px;
  }
}
</style>
